<template>
  <div class="tabs_content" id="tab-2">
    <section>
        <a :data-title="$gettext('Přenačíst aktivitu zařízení')" class="tab_button tab_button_refresh title_tooltip" @click.stop="_reloadDeviceEntity" />

        <div class="status"><h2 v-translate>Poslední aktivita zařízení</h2></div>

        <div class="table_overflow">
          <table class="vypis vypis_detail parovaci_kody">
            <thead>
                <tr v-if="this.methodCallLog.length > 0">
                    <th class="no_padding drag_drop"></th>
                    <th class="no_padding checkbox"></th>
                    <th style="min-width: 100px"><span class="name"><strong v-translate>Metoda</strong></span></th>
                    <th><span v-translate>Obslouženo z</span></th>
                    <th><span v-translate>Název metody</span></th>
                    <th><span v-translate>HTTP Code</span></th>
                    <th><span v-translate>IP</span></th>
                    <th><span v-translate>Datum a čas</span></th>
                    <th class="no_padding"></th>
                </tr>
            </thead>
            <tbody>
                <ActivityRow
                    v-for="(log, index) in activityList"
                    :key="index"
                    :log="log"
                    :selectedEntities="selectedEntities"
                    @input="select"
                    ref="activity_row"
                />
                <tr v-if="this.methodCallLog.length === 0">
                    <td colspan="5" v-translate>Žádná aktivita nebyla zaznamenána.</td>
                </tr>
            </tbody>
        </table>
        </div>
      <local-list-action-line
          :entities="activityList"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
  </div>
</template>

<script>
import ActivityRow from "./ActivityRow";
import localTable from "@/components/mixins/local-table"

export default {
    name: "Activity",
    components: {ActivityRow},
    props: ["methodCallLog"],
    mixins: [localTable],
    methods: {
        _reloadDeviceEntity() {
            this.$emit('reloadEntity');
        }
    },
    computed: {
        entities(){
          return Object.values(this.activityList);
        },
        csvHeaders(){
          return {
            'method': {name: this.$gettext('Metoda')},
            'served-by': {name: this.$gettext('Obslouženo z')},
            'method_description': {name: this.$gettext('Název metody'), callback: (entity, index) => { return this.$refs.activity_row[index].methodDescription()}},
            'code_description': {name: this.$gettext('HTTP Code'), callback: (entity, index) => { return this.$refs.activity_row[index].codeDescription()}},
            'ip': {name: this.$gettext('IP')},
            'timestamp': {name: this.$gettext('Datum a čas')},
          }
        },
        activityList() {
            let list = [...this.methodCallLog.sort((logA, logB) => {
                return logB.timestamp - logA.timestamp;
            })];
            let i = 1;
            list.forEach(item => {
              item['id'] = i;
              i++;
            })

          return list;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/Activity.vue